import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';

import { HealthInsurePopupComponent } from './User/MyPage/HealthInsureSetting/HealthInsurePopup/HealthInsurePopupComponent';
import { PaymentFragmentComponent } from './User/Payment/PaymentFragmentComponent';

import { SharedModule } from '../../SharedModule';
import { NgModule } from '@angular/core';


//////////////////////////////////////////////////////////////////////////////
// MainViewで使用するモジュール
//////////////////////////////////////////////////////////////////////////////
import { MainDisplayComponent } from './MainDisplayComponent';

//////////////////////////////////////////////////////////////////////////////
// 下位のモジュール
//////////////////////////////////////////////////////////////////////////////
import { RegisteredFragmentComponent } from './User/Registered/RegisteredFragmentComponent';

// 設定関連
import { MyPageFragmentComponent } from './User/MyPage/MyPageFragmentComponent';
import { UserInfoPanelComponent } from './User/MyPage/UserInfo/UserInfoPanelComponent';
import { SocialLinkSettingPanelComponent } from './User/MyPage/SocialLinkSetting/SocialLinkSettingPanelComponent';
import { UnlinkSocialPopupComponent } from './User/MyPage/SocialLinkSetting/UnlinkSocialPopup/UnlinkSocialPopupComponent';
import { PasswordResettingPanelComponent } from './User/MyPage/PasswordResetting/PasswordResettingPanelComponent';
import { DiagnoseFragmentComponent } from './User/Diagnose/DiagnoseFragmentComponent';
import { DiagnoseDetailPanelComponent } from './User/Diagnose/DiagnoseDetail/DiagnoseDetailPanelComponent';
import { ForgetPasswordLogginedPopupComponent } from './User/MyPage/PasswordResetting/ForgetPasswordPopup/ForgetPasswordLogginedPopupComponent';
import { PaymentDetailPanelComponent } from './User/Payment/PaymentDetail/PaymentDetailPanelComponent';
import { HealthInsureSettingPanelComponent } from './User/MyPage/HealthInsureSetting/HealthInsureSettingPanelComponent';
import { HomeFragmentComponent } from "./User/Home/HomeFragmentComponent";
import { PcrInterviewFragmentComponent } from "./User/PcrInterview/PcrInterviewFragmentComponent";

// 予約
import { ReserveFragmentComponent } from './User/Reserve/ReserveFragmentComponent';
import {ReserveListPanelComponent} from './User/Reserve/ReserveListPanel/ReserveListPanelComponent';
import {ReserveDetailPanelComponent} from './User/Reserve/ReserveDetailPanel/ReserveDetailPanelComponent';
import {ReserveDepartmentAlertPopoverComponent} from './User/Reserve/ReserveCreateForm/ReserveSelectDetail/ReserveDepartmentAlert/ReserveDepartmentAlertPopoverComponent';
import {ReserveDepartmentSelectPopoverComponent} from './User/Reserve/ReserveCreateForm/ReserveSelectDetail/ReserveDepartmentSelect/ReserveDepartmentSelectPopoverComponent';
import {ReserveDepartmentExamAlertPopoverComponent} from './User/Reserve/ReserveCreateForm/ReserveSelectDetail/ReserveDepartmentExamAlert/ReserveDepartmentExamAlertPopoverComponent';
import {ReserveDepartmentExamSelectPopoverComponent} from './User/Reserve/ReserveCreateForm/ReserveSelectDetail/ReserveDepartmentExamSelect/ReserveDepartmentExamSelectPopoverComponent';
import {ReserveUpdateFragmentComponent} from './User/Reserve/ReserveUpdatePanel/ReserveUpdateFragmentComponent';
import {ReserveUpdateDetailPanelComponent} from './User/Reserve/ReserveUpdatePanel/ReserveUpdateDetail/ReserveUpdateDetailPanelComponent';
import {ReserveUpdateDatePanelComponent} from './User/Reserve/ReserveUpdatePanel/ReserveUpdateDate/ReserveUpdateDatePanelComponent';
import {ReserveUpdateTimePopoverComponent} from './User/Reserve/ReserveUpdatePanel/ReserveUpdateDate/ReserveUpdateTime/ReserveUpdateTimePopoverComponent';
import {ReserveSelectDetailFormFragmentComponent} from './User/Reserve/ReserveCreateForm/ReserveSelectDetail/ReserveSelectDetailFormFragmentComponent';
import {ReserveConfirmFragmentComponent} from './User/Reserve/ReserveCreateForm/ReserveConfirm/ReserveConfirmFragmentComponent';
import {ReserveUserLimitPopoverComponent} from './User/Reserve/ReserveCreateForm/ReserveConfirm/ReserveUserLimitPopover/ReserveUserLimitPopoverComponent';
import {
	ReserveSelectDateFormFragmentComponent
} from './User/Reserve/ReserveCreateForm/ReserveSelectDate/ReserveSelectDateFormFragmentComponent';
import {ReserveCompleteFragmentComponent} from './User/Reserve/ReserveCreateForm/ReserveComplete/ReserveCompleteFragmentComponent';
import {
	ReserveSelectTimePopoverComponent
} from './User/Reserve/ReserveCreateForm/ReserveSelectDate/ReserveSelectTime/ReserveSelectTimePopoverComponent';
import {ReserveConfirmDateFragmentComponent} from './User/Reserve/ReserveCreateForm/ReserveConfirmDate/ReserveConfirmDateFragmentComponent';
import {ReservePopoverAlertComponent} from './User/Reserve/ReservePopoverAlert/ReservePopoverAlertComponent';
import {ReserveAgreementNoneInsureFragmentComponent} from './User/Reserve/ReserveCreateForm/ReserveAgreementNoneInsure/ReserveAgreementNoneInsureFragmentComponent';
import {ReserveOnlineInsureAlreadyAgreedFragmentComponent} from './User/ReserveOnlineInsureAgreement/ReserveOnlineInsureAlreadyAgreed/ReserveOnlineInsureAlreadyAgreedFragmentComponent';

import {DeliveryAddressInputFragmentComponent} from './User/ExamAfterProcess/DeliveryAddressInput/DeliveryAddressInputFragmentComponent';
import {DeliveryAddressConfirmFragmentComponent} from './User/ExamAfterProcess/DeliveryAddressConfirm/DeliveryAddressConfirmFragmentComponent';
import {NotFoundPaymentFragmentComponent} from './User/ExamAfterProcess/NotFoundPayment/NotFoundPaymentFragmentComponent';

import {EditStoreAddressFragmentComponent} from './User/ExamAfterProcess/EditStoreAddress/EditStoreAddressFragmentComponent';
import {EditHomeAddressFragmentComponent} from './User/ExamAfterProcess/EditHomeAddress/EditHomeAddressFragmentComponent';
import {
	EditMedicineDeliveryAddressFragmentComponent
} from './User/ExamAfterProcess/EditMedicineDeliveryAddress/EditMedicineDeliveryAddressFragmentComponent';
import {
	EditPrescriptionDeliveryAddressFragmentComponent
} from './User/ExamAfterProcess/EditPrescriptionDeliveryAddress/EditPrescriptionDeliveryAddressFragmentComponent';
import {HomeAddressOverridePopoverComponent} from './User/ExamAfterProcess/DeliveryAddressInput/HomeAddressOverridePopover/HomeAddressOverridePopoverComponent';
import {ReactiveFormsModule} from '@angular/forms';

// 保険外負担に関する同意書
import {ReserveOnlineInsureAgreementFormFragmentComponent} from './User/ReserveOnlineInsureAgreement/ReserveOnlineInsureAgreementForm/ReserveOnlineInsureAgreementFormFragmentComponent';
import {ReserveOnlineInsureAgreementCompleteFragmentComponent} from './User/ReserveOnlineInsureAgreement/ReserveOnlineInsureAgreementComplete/ReserveOnlineInsureAgreementCompleteFragmentComponent';

// 審査結果関連


//////////////////////////////////////////////////////////////////////////////
// このモジュールは、AppViewModuleで読み込まれる
//////////////////////////////////////////////////////////////////////////////
// 設定関連
const MYPAGE_VIEW = [
	MyPageFragmentComponent,
	UnlinkSocialPopupComponent,
	SocialLinkSettingPanelComponent,
	UserInfoPanelComponent,
	PasswordResettingPanelComponent,
	ForgetPasswordLogginedPopupComponent,
	HealthInsureSettingPanelComponent,
	HealthInsurePopupComponent,
];

const DIAGNOSE_VIEW = [
	DiagnoseFragmentComponent,
	DiagnoseDetailPanelComponent,
];


const PAYMENT_VIEW = [
	PaymentFragmentComponent,
	PaymentDetailPanelComponent
];

const EXAM_AFTER_PROCESS_VIEW = [
	DeliveryAddressInputFragmentComponent,
	DeliveryAddressConfirmFragmentComponent,
	NotFoundPaymentFragmentComponent,
	EditStoreAddressFragmentComponent,
	EditHomeAddressFragmentComponent,
	EditMedicineDeliveryAddressFragmentComponent,
	EditPrescriptionDeliveryAddressFragmentComponent,
	HomeAddressOverridePopoverComponent
];

const RESERVE_VIEW = [
	ReserveFragmentComponent,
	ReserveListPanelComponent,
	ReserveDetailPanelComponent,
	ReserveDepartmentAlertPopoverComponent,
	ReserveDepartmentSelectPopoverComponent,
	ReserveDepartmentExamAlertPopoverComponent,
	ReserveDepartmentExamSelectPopoverComponent,
	ReserveUpdateFragmentComponent,
	ReserveUpdateDetailPanelComponent,
	ReserveUpdateDatePanelComponent,
	ReserveUpdateTimePopoverComponent,
	ReserveSelectDetailFormFragmentComponent,
	ReserveSelectDateFormFragmentComponent,
	ReserveSelectTimePopoverComponent,
	ReserveConfirmFragmentComponent,
	ReserveUserLimitPopoverComponent,
	ReserveConfirmDateFragmentComponent,
	ReserveCompleteFragmentComponent,
	ReservePopoverAlertComponent,
	ReserveAgreementNoneInsureFragmentComponent,
	ReserveOnlineInsureAlreadyAgreedFragmentComponent
];

const RESERVE_ONLINE_INSURE_AGREEMENT_VIEW = [
	ReserveOnlineInsureAgreementFormFragmentComponent,
	ReserveOnlineInsureAgreementCompleteFragmentComponent
];

////////////////////////////////////////////////////////////

@NgModule({
	imports: [
		SharedModule,
		CalendarModule.forRoot({
			provide: DateAdapter,
			useFactory: adapterFactory
		}),
		ReactiveFormsModule,
	],
	declarations: [
		MainDisplayComponent,
		RegisteredFragmentComponent,
		HomeFragmentComponent,
		MYPAGE_VIEW,
		DIAGNOSE_VIEW,
		PAYMENT_VIEW,
		RESERVE_VIEW,
		EXAM_AFTER_PROCESS_VIEW,
		RESERVE_ONLINE_INSURE_AGREEMENT_VIEW
	],
	exports: [
		MainDisplayComponent,
		RegisteredFragmentComponent,
		HomeFragmentComponent,
		MYPAGE_VIEW,
		DIAGNOSE_VIEW,
		PAYMENT_VIEW,
		RESERVE_VIEW,
		EXAM_AFTER_PROCESS_VIEW,
		RESERVE_ONLINE_INSURE_AGREEMENT_VIEW
	],
	entryComponents: [
		MainDisplayComponent,
		RegisteredFragmentComponent,
		HomeFragmentComponent,
		MYPAGE_VIEW,
		DIAGNOSE_VIEW,
		PAYMENT_VIEW,
	],
})
export class ViewDisplayModule {}
